module.exports = __webpack_public_path__ + "static/img/banner3.52de723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner3.png
// module id = W1M9
// module chunks = 19